var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "63px",
    viewBox: "0 0 30 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.29237286,19.5835674 C13.4876592,14.5314255 24.7588063,14.4947444 30.6758698,21.6493437 C30.6972605,21.6753125 30.7158618,21.7031344 30.7372536,21.729102 C36.5903881,20.9718564 42.7176911,22.4246188 48.3957054,24.5484438 C47.6162955,23.3734609 46.8360283,22.1974451 46.0561659,21.0219517 C45.0613974,19.5237475 47.4042583,17.8900487 48.5696352,19.1884892 C50.8464362,21.7244723 52.7939492,24.4432676 54.4518175,27.4188306 C54.924485,28.2656446 54.5664111,29.0284457 53.925133,29.4086829 C53.6182143,29.7003632 53.2085211,29.9020737 52.7937088,29.9391703 C49.6635687,30.2211045 46.7124775,30.8995509 43.7516243,31.9340773 C41.8305757,32.6054961 41.0781063,29.5423019 42.9847858,28.8782668 C44.5365819,28.3380334 46.0973067,27.9095766 47.6774363,27.5719915 C42.8434753,25.7107154 37.5533208,24.3098527 32.4928106,24.6409444 C35.3496155,31.2005735 33.0230523,40.1565958 24.7616873,41.0524817 C20.7470175,41.4879068 16.5473226,39.0056989 16.0902005,34.7845209 C15.634007,30.5717713 18.7999806,26.892263 22.1407173,24.7856508 C23.8054904,23.7353124 25.5326448,22.9771409 27.2988472,22.4540848 C21.6523807,17.063052 11.6095752,18.5579561 6.05703794,23.5855252 C-0.992818897,29.9685152 -4.24065022,41.0817079 -2.04146879,50.2357252 C-1.87172956,50.9410355 -2.8543433,51.3120015 -3.21102426,50.6924823 C-8.88510996,40.8431857 -2.30613724,25.6209951 6.29237286,19.5835674 Z M28.3634366,25.0071486 C26.3310752,25.4948488 24.3660793,26.3627633 22.5213708,27.7187375 C20.6828686,29.0700385 18.6446463,31.4066854 18.6684487,33.9652539 C18.7028649,37.6162984 22.563573,38.7027038 25.2263715,37.5914904 C30.037531,35.5829326 30.7018201,29.3237144 28.3634366,25.0071486 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing",
    transform: "translate(-498.000000, -6525.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 6417.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(138.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(355.331727, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(0.000000, 6.992892)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#00EF91",
    fillRule: "nonzero",
    transform: "translate(24.668284, 33.507149) scale(-1, 1) rotate(-255.000000) translate(-24.668284, -33.507149) ",
    xlinkHref: "#path-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.d1571a76344163309d0419fccd60b38c.svg";
export { ForwardRef as ReactComponent };